import useStudentDashboardConfig from 'AdmissionsGuidance/useStudentDashboardConfig';
import { useEffect, useState } from 'react';
import { isCombinedMobileSidebarBox } from 'StudentDashboardSidebar';

export function useMobileSidebarResponsivePadding() {
    const studentDashboardConfig = useStudentDashboardConfig();
    const [bottomPaddingClass, setBottomPaddingClass] = useState('');

    useEffect(() => {
        if (!studentDashboardConfig) return;
        studentDashboardConfig.mobileSidebarBoxes().then(boxes => {
            const visibleBoxes = boxes.filter(boxConfig =>
                isCombinedMobileSidebarBox(boxConfig)
                    ? !boxConfig.primary.shouldHide && !!boxConfig.primary.mobileContent
                    : !boxConfig.shouldHide && !!boxConfig.mobileContent,
            );
            const className =
                {
                    0: 'pb-0',
                    1: 'pb-[100px] sm:pb-[65px] md:pb-0',
                    2: 'pb-[145px] sm:pb-[130px] md:pb-0',
                    3: 'pb-[190px] sm:pb-[195px] md:pb-0',
                    4: 'pb-[235px] sm:pb-[260px] md:pb-0',
                }[visibleBoxes.length] ?? 'pb-0';
            setBottomPaddingClass(className);
        });
    }, [studentDashboardConfig]);

    return bottomPaddingClass;
}
